module.exports = __webpack_public_path__ + "static/media/7.37140f94.JPG";